var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.8327 16.0003C28.8327 23.088 23.087 28.8337 15.9993 28.8337C8.9117 28.8337 3.16602 23.088 3.16602 16.0003C3.16602 8.91267 8.9117 3.16699 15.9993 3.16699C23.087 3.16699 28.8327 8.91267 28.8327 16.0003Z",
    fill: "white",
    stroke: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4118 15.9995L20.4785 12.9328C20.8652 12.5462 20.8652 11.9062 20.4785 11.5195C20.0918 11.1328 19.4518 11.1328 19.0652 11.5195L15.9985 14.5862L12.9318 11.5195C12.5452 11.1328 11.9052 11.1328 11.5185 11.5195C11.1318 11.9062 11.1318 12.5462 11.5185 12.9328L14.5852 15.9995L11.5185 19.0662C11.1318 19.4528 11.1318 20.0928 11.5185 20.4795C11.7185 20.6795 11.9718 20.7728 12.2252 20.7728C12.4785 20.7728 12.7318 20.6795 12.9318 20.4795L15.9985 17.4128L19.0652 20.4795C19.2652 20.6795 19.5185 20.7728 19.7718 20.7728C20.0252 20.7728 20.2785 20.6795 20.4785 20.4795C20.8652 20.0928 20.8652 19.4528 20.4785 19.0662L17.4118 15.9995Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3fc2c127398820d7c838d5126458ce88.svg";
export { ForwardRef as ReactComponent };